import { AuthContextWrapper } from "../containers/AuthContextWrapper";
import { useAuthContext } from "../containers/AuthContextWrapper";

export { useAuthContext } from "../containers/AuthContextWrapper";
export type { Session } from "@supabase/auth-helpers-react";

export const AuthProvider = AuthContextWrapper;

export function useAuth() {
  return useAuthContext();
}

